// État mutable partagé entre tous les modules WebRTC.
// Même pattern que state.js : un seul objet importé partout.
export const rtcState = {
    // Flux audio
    fluxAudioLocal: null,
    fluxAudioBrut: null,

    // Pipeline RNNoise / mix soundboard
    rnnoiseContext: null,
    rnnoiseWorkletNode: null,
    _mixCtx: null,
    _mixDestination: null,
    suppressionActive: localStorage.getItem('chaos_rnnoise') !== 'false',

    // Soundboard
    _sonBufferCache: {},
    _dernierSonAt: 0,
    _sbPeutGerer: false,
    _sbSphereId: null,
    _sbMode: null,

    // Connexions P2P et éléments audio par pair
    connexionsPairs: {},
    elementsAudio: {},
    gainsAudio: {},
    volumesUtilisateurs: JSON.parse(localStorage.getItem('chaos_user_volumes') || '{}'),
    microCoupe: false,
    sonCoupe: false,

    // Screen share
    fluxVideoLocal: null,
    screenShareSenders: [],   // { pc, sender } — pour cleanup propre

    // Qui parle en ce moment (mis à jour par detecterVoix)
    speakingNow: new Set(),

    // Config STUN
    configWebRTC: {
        iceServers: [
            { urls: 'stun:stun.l.google.com:19302' },
            { urls: 'stun:stun1.l.google.com:19302' }
        ]
    },

    // Participants vocaux par salon { salonId: [pseudo, ...] }
    etatsVocauxActuels: {},

    // Pseudos actuellement en train de streamer (connu côté client)
    pseudosEnStream: new Set(),

    // État appel MP
    appelSortantCible: null,
    appelEntrantCallerId: null,
    countdownRejoinInterval: null,
};
